import { ModalContextProvider } from 'utils/contexts/modal';

import { FacebookLoginContextProvider } from './contexts/FacebookLoginContextProvider';
import { FacebookIntegrationsContextProvider } from './contexts/FacebookIntegrationContextProvider';
import { FacebookIntegrationsPage } from './components/FacebookIntegrationsPage';

export const FacebookIntegrations = () => {
  return (
    <ModalContextProvider>
      <FacebookLoginContextProvider>
        <FacebookIntegrationsContextProvider>
          <FacebookIntegrationsPage />
        </FacebookIntegrationsContextProvider>
      </FacebookLoginContextProvider>
    </ModalContextProvider>
  );
};
